var map = {
	"./Imaryuk1.jpg": 79,
	"./Imaryuk2 copy.jpg": 80,
	"./Imaryuk4-brochure.gif": 81,
	"./Imaryuk6.jpg": 82,
	"./Imaryuk9.jpg": 83,
	"./Oceans-Badges.jpg": 84,
	"./Oceans-hat.jpg": 19,
	"./Plastics7.jpg": 85,
	"./WHB_Gif.gif": 86
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 78;